export const SEND_CONTRACT_SUCCESS = "SEND_CONTRACT_SUCCESS";
export const SEND_CONTRACT_ERROR = "SEND_CONTRACT_ERROR";
export const SEND_CONTRACT_START = "SEND_CONTRACT_START";

export const CONTRACT_DOWNLOAD_BY_OP_SUCCESS =
  "CONTRACT_DOWNLOAD_BY_OP_SUCCESS";
export const CONTRACT_DOWNLOAD_BY_OP_ERROR = "CONTRACT_DOWNLOAD_BY_OP_ERROR";
export const CONTRACT_DOWNLOAD_BY_OP_START = "CONTRACT_DOWNLOAD_BY_OP_START";

export const SIGN_CONTRACT_SUCCESS = "SIGN_CONTRACT_SUCCESS";
export const SIGN_CONTRACT_ERROR = "SIGN_CONTRACT_ERROR";
export const SIGN_CONTRACT_START = "SIGN_CONTRACT_START";

export const CONTRACT_VERIFICATION_SUCCESS = "CONTRACT_VERIFICATION_SUCCESS";
export const CONTRACT_VERIFICATION_ERROR = "CONTRACT_VERIFICATION_ERROR";
export const CONTRACT_VERIFICATION_START = "CONTRACT_VERIFICATION_START";

export const UPLOAD_SING_ADMIN_SUCCESS = "UPLOAD_SING_ADMIN_SUCCESS";
export const UPLOAD_SING_ADMIN_ERROR = "UPLOAD_SING_ADMIN_ERROR";
export const UPLOAD_SING_ADMIN_START = "UPLOAD_SING_ADMIN_START";

export const PUBLISH_PROFILE_SUCCESS = "PUBLISH_PROFILE_SUCCESS";
export const PUBLISH_PROFILE_ERROR = "PUBLISH_PROFILE_ERROR";
export const PUBLISH_PROFILE_START = "PUBLISH_PROFILE_START";
